@if (!checked && questionNumber) {
  {{ questionNumber }}
}
@if (checked) {
  <mat-icon fontSet="zefplayer" class="swiper-no-swiping">check</mat-icon>
}
